<template>
  <el-aside width="200px" class="leftmenu-dark">
    <el-menu :default-openeds="[]" :default-active="menuIndex" @select="onSelect" :unique-opened="true">
      <el-menu-item v-if="$store.state.admin.ID == 1" index="systemLog-list">Log</el-menu-item>
      <!-- <el-menu-item index="homeBanner-list">首頁Banner</el-menu-item> -->
      <el-menu-item v-if="$store.state.admin.AdminLevel > 100" index="message-list"><i class="el-icon-message"></i>聯絡訊息</el-menu-item>
      <el-menu-item v-if="$store.state.admin.AdminLevel > 1000" index="user-list"><i class="el-icon-user"></i>會員管理</el-menu-item>
      <el-menu-item v-if="$store.state.admin.AdminLevel > 1000" index="admin-list"><i class="el-icon-user"></i>工作夥伴</el-menu-item>

      <el-submenu v-if="$store.state.admin.AdminLevel > 100" index="1" class="leftmenu-dark">
        <template slot="title"><span class="expandable"><i class="el-icon-apple"></i>商品管理</span></template>
        <el-menu-item index="product-list">商品列表</el-menu-item>
        <el-menu-item index="productTag-list">商品標籤</el-menu-item>
        <el-menu-item index="productCategoryGroup-list">類別群組</el-menu-item>
        <el-menu-item index="productCategory-list">商品類別</el-menu-item>
        <el-menu-item index="product-statistics">銷售報表</el-menu-item>
      </el-submenu>

      <!-- <el-menu-item v-if="$store.state.admin.AdminLevel > 10" index="order-list"><i class="el-icon-s-order"></i>訂單管理</el-menu-item> -->
      <el-submenu v-if="$store.state.admin.AdminLevel > 10" index="order-management" class="leftmenu-dark">
        <template slot="title"><span class="expandable"><i class="el-icon-s-order"></i>訂單管理</span></template>
        <el-menu-item index="order-list">一般商品</el-menu-item>
        <el-menu-item index="order-list-of-teambuying">團購訂單</el-menu-item>
      </el-submenu>
      <!-- <el-menu-item v-else-if="$store.state.admin.AdminLevel == 10" index="order-list-of-teambuying">團購訂單</el-menu-item> -->
      <el-menu-item v-if="$store.state.admin.AdminLevel == 10" index="teamBuying-statistics"><i class="el-icon-s-order"></i>團購銷售紀錄</el-menu-item>

      <el-menu-item v-if="$store.state.admin.AdminLevel > 100" index="teamBuying-list"><i class="el-icon-goods"></i>團購管理</el-menu-item>
      <!-- <el-menu-item v-if="$store.state.admin.AdminLevel >= 10" index="teamBuying-statistics"><i class="el-icon-s-order"></i>團購銷售紀錄</el-menu-item> -->

      <el-submenu index="promotion-management" class="leftmenu-dark">
        <template slot="title"><span class="expandable"><i class="el-icon-star-off"></i>行銷優惠</span></template>
        <el-menu-item index="coupon-list">折扣碼管理</el-menu-item>
        <el-menu-item index="gift-list">贈品</el-menu-item>
      </el-submenu>

      <el-menu-item v-if="$store.state.admin.AdminLevel > 100" index="settings-shipping-cost"><i class="el-icon-money"></i>運費設定</el-menu-item>

      <el-menu-item v-if="$store.state.admin.AdminLevel > 100" index="store-list"><i class="el-icon-school"></i>店鋪資訊</el-menu-item>

      <el-submenu v-if="$store.state.admin.AdminLevel > 100" index="2" class="leftmenu-dark">
        <template slot="title"><span class="expandable"><i class="el-icon-news"></i>最新情報</span></template>
        <el-menu-item index="productInfo-list">最新情報列表</el-menu-item>
        <el-menu-item index="productInfoTag-list">最新情報類別</el-menu-item>
      </el-submenu>

      <el-submenu v-if="$store.state.admin.AdminLevel > 100" index="3" class="leftmenu-dark">
        <template slot="title"><span class="expandable"><i class="el-icon-location"></i>產地情報</span></template>
        <el-menu-item index="originInfo-list">產地情報列表</el-menu-item>
        <el-menu-item index="originInfoProduct-list">產地水果</el-menu-item>
      </el-submenu>

      <el-submenu v-if="false" index="5" class="leftmenu-dark">
        <template slot="title"><span class="expandable"><i class="el-icon-news"></i>文章</span></template>
        <el-menu-item index="post-list">文章列表</el-menu-item>
        <el-menu-item index="postTag-list">文章#hashtag</el-menu-item>
        <el-menu-item index="author-list">作者</el-menu-item>
      </el-submenu>
      <!-- <el-menu-item index="fbpost-list">FB文章</el-menu-item>
      <el-menu-item index="igpost-list">IG文章</el-menu-item> -->
      <!-- <el-submenu index="4" class="leftmenu-dark">
        <template slot="title"><span class="expandable">QA</span></template>
        <el-menu-item index="qaGroup-list">分類</el-menu-item>
        <el-menu-item index="qa-list">QA</el-menu-item>
      </el-submenu> -->
      <!-- <el-menu-item index="seo">SEO設定</el-menu-item> -->

      <el-submenu v-if="$store.state.admin.AdminLevel > 100" index="6" class="leftmenu-dark">
        <template slot="title"><span class="expandable"><i class="el-icon-setting"></i>網頁設計</span></template>

        <!-- <el-menu-item-group>
          <span slot="title">分组一</span>
          <el-menu-item index="1-1">选项1</el-menu-item>
          <el-menu-item index="1-2">选项2</el-menu-item>
        </el-menu-item-group> -->

        <el-menu-item-group>
          <span slot="title">新首頁</span>
          <el-menu-item v-if="$store.state.admin.ID == 1" index="seo-index">SEO</el-menu-item>
          <el-menu-item index="newHomeBanner-list">Banner</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <span slot="title">產品列表</span>
          <el-menu-item v-if="$store.state.admin.ID == 1" index="seo-products">SEO</el-menu-item>
          <el-menu-item index="homeBanner-list">Banner</el-menu-item>
          <el-menu-item index="webpage-index-menu">選單圖片連結</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <span slot="title">關於旬果屋</span>
          <el-menu-item v-if="$store.state.admin.ID == 1" index="seo-about">SEO</el-menu-item>
          <el-menu-item index="pagecontent-wanwaneditor-about">頁面內容</el-menu-item>
          <el-menu-item index="webpage-aboutBriefInIndex-content">首頁說明</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <span slot="title">人才招募</span>
          <el-menu-item v-if="$store.state.admin.ID == 1" index="seo-recruit">SEO</el-menu-item>
          <el-menu-item index="pagecontent-wanwaneditor-recruit">頁面內容</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <template slot="title"><span class="expandable">商品細節</span></template>
          <el-menu-item index="webpage-product-purchase-process">訂購流程說明</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <template slot="title"><span class="expandable">QA</span></template>
          <el-menu-item v-if="$store.state.admin.ID == 1" index="seo-qa">SEO</el-menu-item>
          <el-menu-item index="qaGroup-list">分類</el-menu-item>
          <el-menu-item index="qa-list">QA</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <template slot="title"><span class="expandable">會員</span></template>
          <el-menu-item index="webpage-member-benefits">會員權益說明</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <template slot="title"><span class="expandable">購物車</span></template>
          <el-menu-item index="webpage-cart-expense-description">步驟三-發票運費說明</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <template slot="title"><span class="expandable">註冊</span></template>
          <el-menu-item index="seo-register">SEO</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <template slot="title"><span class="expandable">登入</span></template>
          <el-menu-item index="seo-login">SEO</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <template slot="title"><span class="expandable">隱私權政策</span></template>
          <el-menu-item v-if="$store.state.admin.ID == 1" index="seo-privacy-policy">SEO</el-menu-item>
          <el-menu-item index="webpage-privacypolicy-content">內文</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <template slot="title"><span class="expandable">顧客條款及細則</span></template>
          <el-menu-item v-if="$store.state.admin.ID == 1" index="seo-terms-of-service">SEO</el-menu-item>
          <el-menu-item index="webpage-termsofservice-content">內文</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group>
          <template slot="title"><span class="expandable">聯絡我們</span></template>
          <el-menu-item index="seo-contact">SEO</el-menu-item>
        </el-menu-item-group>

         <!-- <el-submenu index="5-1" class="leftmenu-dark">
          <template slot="title"><span class="expandable">首頁</span></template>
          <el-menu-item v-if="$store.state.admin.ID == 1" index="seo-index">SEO</el-menu-item>
          <el-menu-item index="homeBanner-list">Banner</el-menu-item>
          <el-menu-item index="webpage-index-menu">選單圖片連結</el-menu-item>
        </el-submenu>

        <el-submenu index="5-3" class="leftmenu-dark">
          <template slot="title"><span class="expandable">商品細節</span></template>
          <el-menu-item index="webpage-product-purchase-process">訂購流程說明</el-menu-item>
        </el-submenu>

        <el-submenu index="5-2" class="leftmenu-dark">
          <template slot="title"><span class="expandable">QA</span></template>
          <el-menu-item v-if="$store.state.admin.ID == 1" index="seo-qa">SEO</el-menu-item>
          <el-menu-item index="qaGroup-list">分類</el-menu-item>
          <el-menu-item index="qa-list">QA</el-menu-item>
        </el-submenu>

        <el-submenu index="5-4" class="leftmenu-dark">
          <template slot="title"><span class="expandable">會員</span></template>
          <el-menu-item index="webpage-member-benefits">會員權益說明</el-menu-item>
        </el-submenu>

        <el-submenu index="5-5" class="leftmenu-dark">
          <template slot="title"><span class="expandable">購物車</span></template>
          <el-menu-item index="webpage-cart-expense-description">步驟三-發票運費說明</el-menu-item>
        </el-submenu>

        <el-submenu v-if="$store.state.admin.ID == 1" index="5-6" class="leftmenu-dark">
          <template slot="title"><span class="expandable">註冊</span></template>
          <el-menu-item index="seo-register">SEO</el-menu-item>
        </el-submenu>

        <el-submenu v-if="$store.state.admin.ID == 1" index="5-7" class="leftmenu-dark">
          <template slot="title"><span class="expandable">登入</span></template>
          <el-menu-item index="seo-login">SEO</el-menu-item>
        </el-submenu>

        <el-submenu index="5-8" class="leftmenu-dark">
          <template slot="title"><span class="expandable">隱私權政策</span></template>
          <el-menu-item v-if="$store.state.admin.ID == 1" index="seo-privacy-policy">SEO</el-menu-item>
          <el-menu-item index="webpage-privacypolicy-content">內文</el-menu-item>
        </el-submenu>

        <el-submenu index="5-9" class="leftmenu-dark">
          <template slot="title"><span class="expandable">顧客條款及細則</span></template>
          <el-menu-item v-if="$store.state.admin.ID == 1" index="seo-terms-of-service">SEO</el-menu-item>
          <el-menu-item index="webpage-termsofservice-content">內文</el-menu-item>
        </el-submenu>

        <el-submenu v-if="$store.state.admin.ID == 1" index="5-10" class="leftmenu-dark">
          <template slot="title"><span class="expandable">聯絡我們</span></template>
          <el-menu-item index="seo-contact">SEO</el-menu-item>
        </el-submenu> -->

        <!-- <el-submenu index="5-2" class="leftmenu-dark">
          <template slot="title"><span class="expandable">文章列表</span></template>
          <el-menu-item index="5-2-1">SEO</el-menu-item>
        </el-submenu> -->
      </el-submenu>

      <el-menu-item v-if="$store.state.admin.AdminLevel > 100" index="contentTemplate-list"><i class="el-icon-document"></i>內容範本</el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  data () {
    return {
      menuIndex: ''
    }
  },
  methods: {
    onSelect (index) {
      this.menuIndex = index

      const pageNames = {
        'index': '首頁',
        'qa': 'QA',
        'register': '註冊',
        'login': '登入',
        'privacy-policy': '隱私權政策',
        'terms-of-service': '顧客條款及細則',
        'contact': '聯絡我們',
        'about': '關於我們',
        'store': '店鋪資訊',
        'product-info': '最新情報',
        'origin-info': '產地情報',
        'recruit': '人才招募'
      }

      // wanwaneditor 內容
      if (index.startsWith('pagecontent-wanwaneditor-')) {
        let page = index.substring('pagecontent-wanwaneditor-'.length)
        const pageNames = {
          'about': '關於旬果屋',
          'recruit': '人才招募'
        }
        this.$router.push({ name: 'webpage-content-wanwaneditor', params: { page: page, title: pageNames[page] } })
        return
      }

      if (index.startsWith('seo-')) {
        let page = index.substring(4)
        this.$router.push({ name: 'webpage-seo', params: { page: page, title: pageNames[page] } })
        return
      }
      this.$router.push({ name: index })
    }
  },
  created () {
    let defaultRouter = this.$store.state.admin.ID === 1 ? 'systemLog-list' : 'message-list'
    if (this.$store.state.admin.AdminLevel == 100) defaultRouter = 'order-list'
    if (this.$store.state.admin.AdminLevel == 10) defaultRouter = 'teamBuying-statistics'
    this.menuIndex = this.$route.name || defaultRouter
  }
}
</script>

<style>
.el-aside {
  color: #333;
}
</style>

<style>
body .el-menu-item,
body .el-submenu__title,
body .el-menu-item-group__title {
  text-align: left;
}
body .el-menu-item-group__title {
  padding-left: 40px !important;
  color: #333;
  font-weight: bold;
  padding: 10px 0 0 20px;
}

.el-menu {
  min-height: 100%;
}
</style>

<style>
/* .el-aside .el-menu-item {
  background-color: #000;
  color: #fff;

  background-color: rgb(247, 247, 247);
  color: rgb(112, 112, 112);
}
.el-aside .el-menu-item.is-active {
  color: #fff;
  font-weight: bold;

  background-color: rgb(255, 255, 255);
  color: rgb(112, 112, 112);
}
.el-aside .el-menu-item:focus,
.el-aside .el-menu-item:hover {
  background-color: #333;
  background-color: rgb(200, 200, 200);
} */
</style>

<style scoped>
/* .expandable {
  color: rgb(112, 112, 112);
  font-weight: bold;
}

.leftmenu-dark {
  background-color: #000;
  color: #fff;

  background-color: rgb(247, 247, 247);
  color: rgb(112, 112, 112);
}
.leftmenu-dark:hover {
  background-color: #000;
  color: #fff;

  background-color: rgb(247, 247, 247);
  color: rgb(112, 112, 112);
}
.leftmenu-dark :hover {
  background-color: #333;
  color: #fff;

  background-color: rgb(200, 200, 200);
  color: rgb(112, 112, 112);
}
.el-submenu .el-menu-item {
  background-color: #333;

  background-color: rgb(247, 247, 247);
}
.el-submenu .el-menu-item:hover {
  background-color: #666;

  background-color: rgb(222, 222, 222);
} */
</style>
